// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34lRg","rootParamsCollapsed":"styles_rootParamsCollapsed__26lCE","rootPreviewFull":"styles_rootPreviewFull__1___9","loader":"styles_loader__GgECc"};